import React from 'react'

// Убираем статическую проверку прав - теперь права проверяются динамически в компонентах
import { ReactComponent as CristmasThree } from '../assets/svg/Header/cristmasthree.svg'

import { ReactComponent as HeaderCart } from '../assets/svg/Header/HeaderCart.svg'
import { ReactComponent as HeaderCatalog } from '../assets/svg/Header/HeaderCatalog.svg'
import { ReactComponent as HeaderMessages } from '../assets/svg/Header/HeaderMessages.svg'
import { ReactComponent as HeaderPeople } from '../assets/svg/Header/HeaderPeople.svg'
import { ReactComponent as OperationLogisticList } from '../assets/svg/Header/OperationLogisticList.svg'

export const overview = [
  {
    permission: null, // Права теперь проверяются динамически
    link: '/admin/orders',
    name: 'Orders',
    icon: (param) => (
      <HeaderCart
        width={'30px'}
        height={'30px'}
        stroke={param?.stroke ? param?.stroke : {}}
      />
    ),
    enabled: true,
    disabled: false,
  },
  // {
  //   permission: null, // Права теперь проверяются динамически
  //   link: '/admin/contacts',
  //   name: `Contacts`,
  //   icon: (param) => (
  //     <HeaderPeople
  //       width={'30px'}
  //       height={'30px'}
  //       stroke={param?.stroke ? param?.stroke : {}}
  //     />
  //   ),
  //   enabled: true,
  //   disabled: false,
  // },
  {
    permission: null, // Права теперь проверяются динамически
    link: '/admin/messages',
    name: `Messages`,
    icon: (param) => (
      <HeaderMessages
        width={'30px'}
        height={'30px'}
        stroke={param?.stroke ? param?.stroke : {}}
      />
    ),
    enabled: false,
    disabled: false,
  },
  {
    permission: null, // Права теперь проверяются динамически
    link: '/admin/logistic',
    name: 'Lista Entregas',
    icon: (param) => (
      <OperationLogisticList
        width={'30px'}
        height={'30px'}
        stroke={param?.stroke ? param?.stroke : {}}
      />
    ),
    enabled: true,
    disabled: false,
  },
]
